import React, { Component } from 'react';
import SignInContainer from '@/containers/content/user/SignIn/SignInContainer';
import LanuageContainer from '@/containers/global/language/LanguageContainer';
class SignInPage extends Component {
    render() {
        return (
            <div className="loginbox">
                <div className="language">
                    <LanuageContainer/>
                </div>
                <SignInContainer />
            </div>
        );
    }
}

export default SignInPage;
